const servicesData = {
  "wedding-entertainment": {
    slug: "wedding-entertainment",
    title: "Wedding Dhol Entertainment",
    metaTitle: "Wedding Dhol Players | Professional Dhol Entertainment for Asian Weddings | Imperial Drummers",
    metaDescription: "Hire professional wedding dhol players for your baraat entrance, milni ceremony & reception. Authentic Punjabi dhol entertainment for Sikh, Hindu & Muslim weddings across the UK & worldwide.",
    keywords: "wedding dhol players, dhol for wedding, baraat dhol, milni dhol, Asian wedding dhol, Punjabi wedding drummers, Sikh wedding dhol, Hindu wedding dhol, wedding dhol hire, dhol entertainment wedding",

    hero: {
      heading: "Wedding Dhol Entertainment",
      subheading: "Make your wedding entrance unforgettable with the powerful beats of authentic Punjabi dhol. Our professional drummers bring energy, tradition, and spectacle to your special day.",
      badge: "Weddings"
    },

    intro: {
      heading: "The Heartbeat of Your Wedding Day",
      paragraphs: [
        "The dhol is the soul of a South Asian wedding. From the moment the groom arrives at the venue to the final dance of the night, the thundering beats of the dhol set the tone for celebration, joy, and unforgettable memories.",
        "At Imperial Drummers, we've performed at over 2,000 weddings across the UK and internationally. Our drummers don't just play - they read the crowd, build energy, and create moments that your guests will talk about for years to come.",
        "Whether you're planning a grand Punjabi wedding, an elegant Hindu ceremony, or a vibrant fusion celebration, our professional dhol players deliver performances tailored to your vision."
      ]
    },

    services: [
      {
        title: "Baraat Entrance",
        description: "The groom's arrival is the first major moment of the wedding. Our dhol players lead the baraat procession with high-energy beats, creating an electrifying atmosphere as the groom makes his grand entrance.",
        icon: "music"
      },
      {
        title: "Milni Ceremony",
        description: "The meeting of the two families deserves a soundtrack of its own. Our drummers provide the perfect backdrop for the milni, building excitement and emotion as garlands are exchanged.",
        icon: "event"
      },
      {
        title: "Reception Entertainment",
        description: "Keep the energy alive throughout your reception. From the couple's entrance to the dance floor, our dhol players work alongside your DJ to create non-stop entertainment.",
        icon: "star"
      },
      {
        title: "Vidaai & Send-Off",
        description: "Close the celebrations with a powerful send-off. Our drummers provide an emotional yet energetic farewell performance that brings the entire wedding to a memorable close.",
        icon: "group"
      }
    ],

    weddingTypes: [
      {
        type: "Sikh Weddings",
        description: "Traditional Anand Karaj celebrations with dhol for the baraat, milni, and reception. We understand the flow of Sikh wedding ceremonies and time our performances perfectly."
      },
      {
        type: "Hindu Weddings",
        description: "From the baraat to the vidaai, our dhol players complement every stage of the Hindu wedding ceremony with authentic rhythms and high energy."
      },
      {
        type: "Muslim Weddings",
        description: "Professional dhol entertainment for nikah celebrations, walima receptions, and mehndi nights. Respectful, energetic performances tailored to your event."
      },
      {
        type: "Fusion Weddings",
        description: "Blending cultures? Our dhol players seamlessly integrate with Western music, DJs, and bands to create a unique cross-cultural celebration."
      }
    ],

    process: [
      {
        step: 1,
        title: "Get in Touch",
        description: "Fill out our booking form or call us with your wedding date, venue, and vision. We'll discuss your requirements and recommend the perfect package."
      },
      {
        step: 2,
        title: "Personalise Your Package",
        description: "Choose your dhol players, outfit style, and performance schedule. We'll coordinate with your wedding planner, DJ, and venue to ensure everything runs smoothly."
      },
      {
        step: 3,
        title: "The Big Day",
        description: "Our team arrives early, sets up, and delivers a show-stopping performance. From the first beat to the last, we make your wedding unforgettable."
      }
    ],

    faqs: [
      {
        question: "How many dhol players do I need for my wedding?",
        answer: "For most weddings, we recommend 2 dhol players - this delivers a great balance of sound and visual impact. For larger venues or grand celebrations, 3-5 players create an immersive experience. A solo dhol player works well for intimate ceremonies or as an addition to your baraat."
      },
      {
        question: "When should the dhol players perform during the wedding?",
        answer: "The most popular timings are the baraat (groom's arrival), milni (family meeting), and during the reception party. Many couples also add dhol for the couples entrance. We'll work with your planner to time everything perfectly."
      },
      {
        question: "Can you perform alongside a DJ or live band?",
        answer: "Absolutely. We regularly perform alongside DJs, bands, and MCs. Our drummers are experienced in reading the flow of an event and coordinating with other entertainment to create a seamless experience."
      },
      {
        question: "Do you provide luxury or themed outfits?",
        answer: "Yes. We offer a range of outfit options from traditional Punjabi attire to premium luxury costumes. Ask us about our outfit options when booking."
      },
      {
        question: "How far in advance should I book?",
        answer: "We recommend booking at least 3-6 months in advance, especially for peak wedding season (April-September). Popular dates book up quickly, so early enquiry is best to secure your preferred date."
      },
      {
        question: "Do you travel outside the UK for weddings?",
        answer: "Yes - we've performed at destination weddings across Europe, USA, Canada, India, Dubai, and beyond. International travel logistics are handled by our team so you don't have to worry about a thing."
      }
    ],

    relatedServices: [
      { slug: "corporate-events", name: "Corporate Events" },
      { slug: "cultural-festivals", name: "Cultural Festivals" },
      { slug: "media-and-production", name: "Media & Production" }
    ]
  },

  "corporate-events": {
    slug: "corporate-events",
    title: "Corporate Events",
    metaTitle: "Corporate Dhol Entertainment | Dhol Players for Corporate Events | Imperial Drummers",
    metaDescription: "Professional dhol entertainment for corporate events, product launches, Diwali celebrations & company parties. Energise your next corporate event with Imperial Drummers.",
    keywords: "corporate dhol entertainment, dhol for corporate events, Diwali corporate event, product launch entertainment, company party dhol, corporate entertainment UK, dhol hire corporate",

    hero: {
      heading: "Corporate Event Entertainment",
      subheading: "Elevate your corporate event with the electrifying energy of live dhol entertainment. From product launches to Diwali celebrations, we deliver performances that leave a lasting impression.",
      badge: "Corporate"
    },

    intro: {
      heading: "Entertainment That Means Business",
      paragraphs: [
        "Corporate events demand something memorable - something that cuts through the noise and gives your guests an experience they'll talk about long after the event ends. That's exactly what Imperial Drummers deliver.",
        "We've performed for some of the biggest names in business, including Meta, Freshworks, and BBC Asian Network. Whether it's a product launch, an awards ceremony, or a company Diwali celebration, our professional dhol players bring an energy that transforms any corporate setting.",
        "Our team works closely with your event organisers to deliver a performance that fits your schedule, your venue, and your brand. Professional, punctual, and always show-stopping."
      ]
    },

    services: [
      {
        title: "Product Launches",
        description: "Make your product launch unforgettable. Our dhol players create a high-energy reveal moment that builds excitement and gets your audience on their feet.",
        icon: "star"
      },
      {
        title: "Diwali Celebrations",
        description: "Bring authenticity to your corporate Diwali event. Our drummers deliver traditional Punjabi and Bollywood beats that capture the spirit of the festival of lights.",
        icon: "event"
      },
      {
        title: "Awards & Galas",
        description: "Add a spectacular entrance or interlude to your awards evening. Our performers bring energy and prestige to black-tie events and corporate galas.",
        icon: "music"
      },
      {
        title: "Team Events & Parties",
        description: "From summer parties to end-of-year celebrations, our dhol players get everyone involved and create a shared experience your team won't forget.",
        icon: "group"
      }
    ],

    process: [
      {
        step: 1,
        title: "Brief Us",
        description: "Share your event details - date, venue, audience size, and the vibe you're going for. We'll recommend the right setup for your event."
      },
      {
        step: 2,
        title: "Plan the Performance",
        description: "We coordinate with your event team on timings, staging, and any special requirements. Everything is tailored to fit your programme seamlessly."
      },
      {
        step: 3,
        title: "Showtime",
        description: "Our team arrives on time, sets up discreetly, and delivers a performance that energises your audience and elevates your event."
      }
    ],

    faqs: [
      {
        question: "What types of corporate events do you perform at?",
        answer: "We perform at product launches, Diwali celebrations, awards ceremonies, company parties, team-building events, brand activations, and more. If your event needs energy, we can deliver."
      },
      {
        question: "Can you tailor the performance to our brand or theme?",
        answer: "Yes. We work with your event team to match the tone and timing of your programme. We can adjust outfit styles, performance intensity, and duration to suit your event."
      },
      {
        question: "How much space do the dhol players need?",
        answer: "Our performers are flexible and can work in a range of venue sizes - from intimate boardroom events to large conference halls and outdoor spaces. We'll advise on the best setup for your venue."
      },
      {
        question: "Do you have public liability insurance?",
        answer: "Yes. We carry full public liability insurance and can provide documentation to your venue or event organisers on request."
      },
      {
        question: "Can you perform alongside other entertainment?",
        answer: "Absolutely. We regularly coordinate with DJs, MCs, bands, and AV teams to deliver a seamless experience as part of a wider entertainment programme."
      }
    ],

    relatedServices: [
      { slug: "wedding-entertainment", name: "Wedding Entertainment" },
      { slug: "cultural-festivals", name: "Cultural Festivals" },
      { slug: "media-and-production", name: "Media & Production" }
    ]
  },

  "cultural-festivals": {
    slug: "cultural-festivals",
    title: "Cultural Festivals",
    metaTitle: "Dhol Players for Cultural Festivals | Festival Entertainment | Imperial Drummers",
    metaDescription: "Professional dhol entertainment for cultural festivals, melas, Vaisakhi celebrations, Navratri events & community gatherings across the UK and worldwide.",
    keywords: "dhol players festival, cultural festival entertainment, mela dhol players, Vaisakhi dhol, Navratri entertainment, community event dhol, festival drummers UK, dhol hire festival",

    hero: {
      heading: "Cultural Festival Entertainment",
      subheading: "From parades to melas, our dhol players bring authentic energy and crowd-pulling performances to cultural festivals of every scale.",
      badge: "Festivals"
    },

    intro: {
      heading: "The Sound of Celebration",
      paragraphs: [
        "Cultural festivals are built on energy, community, and tradition - and nothing captures that spirit quite like live dhol. The sound of the dhol cuts through the crowd, draws people in, and gets everyone moving.",
        "Imperial Drummers have performed at festivals across the UK and internationally, from large-scale melas and Vaisakhi parades to intimate community celebrations. Our drummers bring raw, authentic energy that connects with audiences of all backgrounds.",
        "Whether you're organising a council-run festival, a community Diwali event, or a private cultural celebration, we deliver professional performances that become the highlight of your programme."
      ]
    },

    services: [
      {
        title: "Parades",
        description: "Lead your parade or Nagar Kirtan with powerful dhol beats. Our players march with the procession, keeping energy high from start to finish.",
        icon: "music"
      },
      {
        title: "Melas & Fairs",
        description: "Draw crowds and set the atmosphere at your mela or cultural fair. Our dhol players perform walkabout sets and stage shows that keep audiences engaged all day.",
        icon: "group"
      },
      {
        title: "Diwali & Navratri",
        description: "Authentic dhol entertainment for Diwali switch-on events, Navratri garba nights, and other religious and cultural celebrations throughout the year.",
        icon: "event"
      },
      {
        title: "Community Events",
        description: "From heritage days to charity events and council-organised festivals, our drummers add a dynamic, crowd-pleasing element to any community gathering.",
        icon: "star"
      }
    ],

    process: [
      {
        step: 1,
        title: "Tell Us About Your Festival",
        description: "Share your event details - date, location, expected audience, and programme schedule. We'll recommend the right number of performers and set format."
      },
      {
        step: 2,
        title: "Coordinate & Plan",
        description: "We work with your event organisers on staging, timings, and logistics. For parades, we'll plan the route and performance points together."
      },
      {
        step: 3,
        title: "Deliver the Energy",
        description: "Our performers arrive ready to go and deliver high-energy sets that captivate your audience and keep the festival atmosphere alive."
      }
    ],

    faqs: [
      {
        question: "Can you perform outdoor sets at festivals?",
        answer: "Yes. Our dhol drums are acoustic instruments that project naturally - no amplification needed. We perform outdoors in all conditions and can adapt to any festival setting."
      },
      {
        question: "Do you offer walkabout performances?",
        answer: "Yes. Walkabout sets are one of our most popular festival formats. Our drummers move through the crowd, creating pockets of energy and drawing people into the festival atmosphere."
      },
      {
        question: "How long can you perform at a festival?",
        answer: "We offer flexible performance durations - from a single 30-minute set to full-day coverage with multiple sets and breaks. We'll structure the performance to fit your programme."
      },
      {
        question: "Can you perform as part of a parade or procession?",
        answer: "Absolutely. We have extensive experience performing in Vaisakhi parades, Nagar Kirtans, and carnival processions. Our drummers march with the procession and keep the energy high throughout."
      },
      {
        question: "Do you work with councils and event management companies?",
        answer: "Yes. We regularly work with local councils, event management companies, and festival organisers. We carry full public liability insurance and can provide all documentation required."
      }
    ],

    relatedServices: [
      { slug: "wedding-entertainment", name: "Wedding Entertainment" },
      { slug: "corporate-events", name: "Corporate Events" },
      { slug: "media-and-production", name: "Media & Production" }
    ]
  },

  "media-and-production": {
    slug: "media-and-production",
    title: "Media & Production",
    metaTitle: "Dhol Players for Film, TV & Music Production | Imperial Drummers",
    metaDescription: "Professional dhol players for music videos, film & TV productions, radio sessions, and recording projects. Authentic dhol performances for media and creative productions.",
    keywords: "dhol players music video, dhol for film, dhol TV production, dhol recording session, dhol radio performance, dhol players media, dhol hire production, dhol session musicians",

    hero: {
      heading: "Media & Production",
      subheading: "Professional dhol players for music videos, film and TV productions, radio sessions, and studio recordings. Authentic performances crafted for the camera and the microphone.",
      badge: "Production"
    },

    intro: {
      heading: "Dhol for the Screen and Studio",
      paragraphs: [
        "Imperial Drummers bring the same energy and professionalism to media productions as we do to live events. Whether you need dhol players for a music video shoot, a film scene, a TV appearance, or a studio recording session, we deliver.",
        "We've worked with BBC Asian Network, appeared on television productions, and collaborated with artists and production companies across the UK. Our drummers understand the demands of working on set - hitting marks, repeating takes, and performing consistently under direction.",
        "From one-off recording sessions to multi-day shoots, we provide professional dhol musicians who are comfortable in front of the camera and behind the microphone."
      ]
    },

    services: [
      {
        title: "Music Videos",
        description: "Professional dhol players for music video shoots. Our performers are camera-ready and experienced in working with directors and production crews to deliver the visuals you need.",
        icon: "music"
      },
      {
        title: "Film & Television",
        description: "Authentic dhol performances for film scenes, TV programmes, and documentaries. We provide musicians who can take direction and deliver consistent performances across multiple takes.",
        icon: "star"
      },
      {
        title: "Radio & Live Sessions",
        description: "Live dhol performances for radio broadcasts, podcast recordings, and live session content. Our players deliver high-energy performances tailored for audio production.",
        icon: "event"
      },
      {
        title: "Studio Recording",
        description: "Session dhol musicians for studio recordings, album tracks, and audio production. Clean, professional dhol recordings to complement your project.",
        icon: "group"
      }
    ],

    process: [
      {
        step: 1,
        title: "Share Your Brief",
        description: "Tell us about your production - the format, the look and feel, the schedule, and what you need from the dhol performance. We'll advise on the best setup."
      },
      {
        step: 2,
        title: "Pre-Production",
        description: "We coordinate with your production team on logistics, call times, wardrobe, and any specific performance requirements for the shoot or session."
      },
      {
        step: 3,
        title: "On Set / In Studio",
        description: "Our performers arrive on time, take direction professionally, and deliver consistent, high-quality performances - whether it's take one or take twenty."
      }
    ],

    faqs: [
      {
        question: "Do your dhol players have experience working on set?",
        answer: "Yes. Our performers have worked on music video shoots, TV productions, and live broadcasts. They understand the pace of production work - hitting marks, repeating takes, and working with directors and crew."
      },
      {
        question: "Can you provide dhol for a studio recording?",
        answer: "Yes. We provide experienced session musicians for studio recording projects. Our players can work to a click track, follow arrangements, and deliver clean takes for your production."
      },
      {
        question: "What should we provide on set for the dhol players?",
        answer: "We bring our own instruments and can provide our own costumes. We just need a reasonable space to perform, and for outdoor shoots, basic shelter during breaks. We'll discuss specific requirements during pre-production."
      },
      {
        question: "Can you match a specific look or costume for our production?",
        answer: "Yes. We have a range of outfit options from traditional Punjabi attire to luxury costumes. For specific production requirements, we can discuss custom wardrobe to match your creative vision."
      },
      {
        question: "How do you handle licensing and rights for recorded performances?",
        answer: "We're happy to discuss licensing and usage rights for any recorded content. Get in touch with the details of your project and we'll work out an arrangement that suits both parties."
      }
    ],

    relatedServices: [
      { slug: "wedding-entertainment", name: "Wedding Entertainment" },
      { slug: "corporate-events", name: "Corporate Events" },
      { slug: "cultural-festivals", name: "Cultural Festivals" }
    ]
  }
};

export const getServiceBySlug = (slug) => servicesData[slug] || null;

export const getAllServices = () => Object.values(servicesData);

export const getAllServiceSlugs = () => Object.keys(servicesData);

export default servicesData;
